import { clearStorage, getStorageItem, removeStorageItem, setStorageItem, STORAGE_UPDATE_EVENT } from "@/libs/local-storage";

export default defineNuxtPlugin(() => {
    const nuxtApp = useNuxtApp();
    const wrappedSetItem = <T>(...args: Parameters<typeof setStorageItem<T>>) => {
        setStorageItem(...args);
        nuxtApp.$trigger(STORAGE_UPDATE_EVENT, { key: args[0], value: args[1] });
    };

    const wrappedRemoveItem = (...args: Parameters<typeof removeStorageItem>) => {
        removeStorageItem(...args);
        nuxtApp.$trigger(STORAGE_UPDATE_EVENT, { key: args[0], value: null });
    };

    const wrappedClearStorage = (...args: Parameters<typeof clearStorage>) => {
        clearStorage(...args);
        nuxtApp.$trigger(STORAGE_UPDATE_EVENT, { key: "*", value: null });
    };

    if (import.meta.client) {
        window.addEventListener("storage", (event) => {
            // Bridge cross-tab storage changes to our internal event bus
            if (event.key) {
                nuxtApp.$trigger(STORAGE_UPDATE_EVENT, { key: event.key, value: getStorageItem(event.key) });
            } else if (event.key === null) {
                // localStorage.clear()
                nuxtApp.$trigger(STORAGE_UPDATE_EVENT, { key: "*", value: null });
            }
        });
    }

    return {
        provide: {
            setStorageItem: wrappedSetItem,
            getStorageItem,
            removeStorageItem: wrappedRemoveItem,
            clearStorage: wrappedClearStorage,
        },
    };
});
